import { BaseService } from '../../../../../core/services/base.service';
import { Client, ClientId } from '../models/clients.model';
export class ClientsService {
  static async GetClients(
    companyId: string,
    params?: {
      page?: number;
      size?: number;
      sort?: string;
      filter?: string;
    }
  ): Promise<{ content: ClientId[]; totalElements: number }> {
    const query = params
      ? `?${new URLSearchParams(params as Record<string, string>).toString()}`
      : '';

    const result: { content: ClientId[]; totalElements: number } =
      await BaseService.Get(`/companies/${companyId}/clients${query}`);
    return {
      ...result,
      content: (result?.content ?? []).map((client) => ({
        ...client,
        active: client.active ?? client.isActive ?? true,
        currency: client.currency ?? '',
      })),
    };
  }

  static async GetById(companyId: string, clientId: string): Promise<ClientId> {
    return await BaseService.Get(`/companies/${companyId}/clients/${clientId}`);
  }

  static async Post(companyId: string, client: Client): Promise<ClientId> {
    return await BaseService.Post(`/companies/${companyId}/clients`, {
      name: client.name,
      website: client.website,
      active: client.active,
      primaryContact: client.primaryContact,
      primaryEmail: client.primaryEmail,
      primaryPhoneNumber: client.primaryPhoneNumber,
      currency: client.currency,
    });
  }

  static async Patch(
    companyId: string,
    client: Client,
    clientId: string
  ): Promise<Client> {
    return await BaseService.Patch(
      `/companies/${companyId}/clients/${clientId}`,
      {
        name: client.name,
        website: client.website,
        active: client.active,
        primaryContact: client.primaryContact,
        primaryEmail: client.primaryEmail,
        primaryPhoneNumber: client.primaryPhoneNumber,
        currency: client.currency,
      }
    );
  }

  static async Delete(
    companyId: string,
    clientId: string
  ): Promise<ClientId[]> {
    return await BaseService.Delete(
      `/companies/${companyId}/clients/${clientId}`
    );
  }

  static async GetCurrency() {
    return await BaseService.Get('/public/currencies');
  }
}
